import RightArrowIcon from '@assets/icons/arrow-right-long.svg?react'
import CheckIcon from '@assets/icons/check.svg?react'
import { breakpoints } from '@constants'
import { useHeaderContext } from '@context/HeaderContext'
import cn from 'classnames'
import { isValidArray, useMatchMedia } from 'mmfintech-commons'
import React from 'react'

import styles from './HeaderSteps.module.scss'

const HeaderSteps = () => {
  const { currentStep, totalSteps } = useHeaderContext()

  const isLarge = useMatchMedia({ breakpoint: breakpoints.xl, prefix: 'max' })

  return isValidArray(totalSteps) ? (
    isLarge ? (
      <div className={styles['header-steps-mobile']} data-test='header-steps-mobile'>
        <span>
          {currentStep > totalSteps.length ? totalSteps.length : currentStep}/{totalSteps.length}
        </span>
      </div>
    ) : (
      <div className={styles['header-steps']} data-test='header-steps'>
        {totalSteps.map(({ context, step }) => {
          const active = currentStep === step
          return (
            <React.Fragment key={step}>
              <div
                className={cn(styles['header-step-wrapper'], { active })}
                data-test={active ? 'header-step-active' : undefined}
              >
                <div className='step'>{currentStep > step ? <CheckIcon /> : <span>{step}</span>}</div>
                <div>{context}</div>
              </div>
              {totalSteps?.length > step && (
                <div className={cn(styles['header-step-arrow'], { active })}>
                  <RightArrowIcon />
                </div>
              )}
            </React.Fragment>
          )
        })}
      </div>
    )
  ) : null
}

export default HeaderSteps
